import React, { useEffect, useState } from 'react'
import GeneralService from '../../apis/GeneralService'
import ApiURL from '../../apis/ApiURL'
import Constants from '../../utility/Constants'
import { useDispatch, useSelector } from 'react-redux'
import { listProvider } from '../../redux/slices/ProviderSlice'
import { Link } from 'react-router-dom'
import { FormattedMessage } from "react-intl";
import enMessages from '../../utility/language/english.json'
import koMessages from '../../utility/language/korean.json'
const ProviderList = () => {

    const dispatch = useDispatch();
    const providerState = useSelector((state) => state.providerState);
    const languageState = useSelector((state) => state.languageState);
    let languageCode = languageState.active_language.language_code;
    
    const [searchTerm, setSearchTerm] = useState('');
    
    // Filter providers based on search term
    const filteredProviders = providerState.provider_list?.filter(provider => 
        provider.provider_name?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

    const allMessages = {
        en: enMessages,
        ko: koMessages,
    }

    let messages = allMessages[languageCode];
    /**
* @author Swarnali Ghosh
* @Date_Created 12/03/2024
* @Date_Modified 12/03/2023
* @function async
* @functionName loadProviderList
* @functionPurpose this function gets provider list.
* @functionParam {}
* @functionSuccess Success status and message.
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/

    async function loadProviderList() {

        GeneralService.apiGetCallRequestWithWToken(ApiURL.getProviderList).then(res => {
            if (res.error == Constants.API_RESPONSE_ERROR_FALSE) {
                dispatch(listProvider(res.data))
            }
        }).catch(error => {

        })

    }

    useEffect(() => {
        window.scrollTo(0, 0);

        loadProviderList();

    }, [])

    return (
        <div className='container' >
            <div className='provider-heading-section'>

                <span> <FormattedMessage
                    id="PROVIDER"
                /></span>
                
                <div className='provider-search-section'>
                    <div className='provider-search-container'>
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input 
                            type='text' 
                            placeholder={languageCode === "en" ? "Search provider" : "공급자 검색"}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className='provider-search-input'
                        />
                    </div>
                </div>

            </div>
            <div className='provider-detail-page-section'>
                <div className='povider-list-section'>
                    {
                        filteredProviders.length > 0 ? filteredProviders.map((providerData, providerIndex) => (
                            <Link to="/provider-detail" className='p-1' style={{width:"18%", marginRight:"2%"}} state={{ "provider_id": providerData._id, "provider_name": providerData.provider_name }} key={providerIndex}>
                                <div className='provider_logo'>
                                    <img src={providerData.provider_logo} alt="provider_img" />
                                </div>
                            </Link>
                        )) :
                            ""
                    }

                </div>


            </div>
        
        {/* Search Input Styles */}
        <style>{`
            .provider-heading-section {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;
            }
            
            .provider-search-section {
                display: flex;
                align-items: center;
            }
            
            .provider-search-container {
                position: relative;
                width: 100%;
                max-width: 400px;
            }
            
            .provider-search-container i {
                position: absolute;
                left: 15px;
                top: 50%;
                transform: translateY(-50%);
                color: #a0aec0;
            }
            
            .provider-search-input {
                width: 100%;
                padding: 12px 15px 12px 45px;
                border: 1px solid #4a5568;
                border-radius: 25px;
                font-size: 16px;
                outline: none;
                transition: border-color 0.3s ease;
                background-color: transparent;
                color: #e2e8f0;
            }
            
            .provider-search-input:focus {
                border-color: #718096;
            }
            
            .provider-search-input::placeholder {
                color: #a0aec0;
            }
        `}</style>
        </div>
    )
}

export default ProviderList